import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DetailsPageRoutingModule } from './details-page-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { BootstrapMembersTabsComponent } from './bootstrap-members-tabs/bootstrap-members-tabs.component';
import { ThirdNavTabComponentComponent } from 'src/app/common-page-components/third-nav-tab-component/third-nav-tab-component.component';
import { CommonPageComponentsModule } from 'src/app/common-page-components/common-page-components.module';
import { MembersRouterInterceptorService } from './services/members-router-interceptor.service';
import { ComponentsModule } from '../../library/components/components/components.module';
import { ServicesModule } from 'world-archery-lib';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
@NgModule({
  declarations: [BootstrapMembersTabsComponent],
  imports: [
    CommonModule,
    DetailsPageRoutingModule,
    HttpClientModule,
    CommonPageComponentsModule,
    ComponentsModule,
    ServicesModule,

  ],
  providers:[MembersRouterInterceptorService]
})
export class DetailsPageModule {
  constructor() {

  }
}
